var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoOverlayMailDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 6.66699C5.55634 6.66699 4.57762 7.21212 3.97428 8.05046C3.56762 8.61379 3.74728 9.4123 4.33561 9.77897L18.971 18.9001C19.601 19.2934 20.3983 19.2934 21.0283 18.9001L35.6019 9.70085C36.2136 9.31418 36.3661 8.47381 35.9144 7.91048C35.3061 7.15381 34.378 6.66699 33.333 6.66699H6.66634ZM35.859 13.4769C35.7197 13.4784 35.5781 13.5168 35.4456 13.6006L21.0283 22.6924C20.3983 23.084 19.601 23.0825 18.971 22.6891L4.55046 13.7048C4.02046 13.3748 3.33301 13.7568 3.33301 14.3818V30.0003C3.33301 31.842 4.82467 33.3337 6.66634 33.3337H33.333C35.1747 33.3337 36.6663 31.842 36.6663 30.0003V14.2744C36.6663 13.8044 36.2772 13.4723 35.859 13.4769Z",
    fill: "url(#paint0_linear_181252_183668)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181252_183668",
    x1: 19.9997,
    y1: 6.66699,
    x2: 19.9997,
    y2: 21.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOverlayMailDark);
export default __webpack_public_path__ + "static/media/video-overlay-mail-dark.bd527c7b97a1f9a8922a2a8b6940243c.svg";
export { ForwardRef as ReactComponent };